module.exports = __webpack_public_path__ + "static/img/img_chanpin_zhongxin_banner.a67f2ab3.png";